import * as React from 'react'
import { useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { SectionDetailsState } from '../../features/types'

interface Props {
    title: string
    open: boolean
    confirmAction: () => void
    handleClose: () => void
    description?: string
    sectionDetails?: SectionDetailsState
}

const StartExamDialog: React.FC<Props> = ({
    title,
    sectionDetails,
    confirmAction,
    open,
    handleClose,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Dialog
            maxWidth={'xs'}
            fullWidth
            open={open}
            onClose={handleClose}
        >
            <DialogTitle textAlign={'center'}>{title}</DialogTitle>

            <DialogContent>
                <DialogContentText textAlign={'center'}>
                    {formatMessage({ id: 'exam_start_warning_line_1' })}
                </DialogContentText>

                <DialogContentText textAlign={'center'}>
                    {formatMessage({ id: 'duration' })}:{' '}
                    {sectionDetails?.duration} минут
                </DialogContentText>

                <DialogContentText textAlign={'center'}>
                    {formatMessage({ id: 'numberOfQuestions' })}:{' '}
                    {sectionDetails?.countQuestions}
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ m: 2, justifyContent: 'center' }}>
                <Button onClick={handleClose}>
                    {formatMessage({ id: 'cancel' })}
                </Button>

                <Button
                    variant="contained"
                    onClick={() => {
                        confirmAction()
                        handleClose()
                    }}
                >
                    {formatMessage({ id: 'start' })}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default StartExamDialog
